import { createStore as originalCreateStore } from 'redux';
import { communicationsReducer } from './reducers';
import memes from '../../memes';
export const createStore = memes((initialState) => {
    return originalCreateStore(communicationsReducer, initialState);
});
